import { jsx, jsxs } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
function StoreLocatorPart({ part }) {
  if (isCallState(part.state)) return /* @__PURE__ */ jsx("div", { className: "concierge-loading", children: "Finding stores..." });
  if (isOutputState(part.state) && part.output) {
    return /* @__PURE__ */ jsx("div", { className: "concierge-store-locator", children: part.output.isOnlineOnly ? /* @__PURE__ */ jsx("div", { children: "This product is available online only." }) : part.output.hasStores ? /* @__PURE__ */ jsxs("div", { children: [
      "Store locator: ",
      part.output.stacklineSku
    ] }) : /* @__PURE__ */ jsx("div", { children: "No nearby stores found for this product." }) });
  }
  return null;
}
export {
  StoreLocatorPart
};
//# sourceMappingURL=StoreLocatorPart.js.map
